import flatpickr from "flatpickr";
import { German } from "flatpickr/dist/l10n/de.js";
import {swiperMultistep, apiService} from '../custom/tariff_api.es6'; // Import Swiper
import {sendTag} from "../custom/tag-managers.es6";


const swiperContainer = ".multistep-slider.swiper-container";
const sectionAccordion = $('.section-accordion');

let clickedButtons = []; // Array to store already clicked buttons


jQuery(document).ready(function ($) {
    const form = $("#multistep-form, #revision-form");
    const multistepForm = $("#multistep-form");
    const revisionForm = $("#revision-form");
    const inputs = $('.ninja-forms-field:not(.select2-hidden-accessible)');
    const nextButtons = $('.button-next');
    const prevLinks = $('.back-link a');
    const formBox = $('.form-box');
    const selectsAll = $('.listselect-container select, .textbox_with_tooltip-container select');
    const simpleDatePicker = $(".date-container .datepicker");
    const customDatePicker = $(".date-container .datepicker-18");
    const custom2DatePicker = $(".date-container .datepicker-5");


    // if (!form) return false;
    function applyCouponToUI(data) {
        const $container = $('.promocode-container');
        const $promocodeSuccess = $('.promocode-success');

        // set values to apiService
        apiService.couponCode = data.code || null;
        apiService.couponArt = data.art || null;
        apiService.couponValue = data.value || null;

        // block + hide input/button so user can't type
        $container.removeClass('required-label').addClass('blocked').empty();

        // success message (same markup as your click flow)
        const msg = data.success_message || '';
        if ($promocodeSuccess.length) {
            $promocodeSuccess.find('.nf-field-element').html('<div class="text-3">' + msg + '</div>');
        } else {
            $container.after(
                '<div class="nf-field-container html-container promocode-success -h4-container">' +
                '  <div class="field-wrap html-wrap">' +
                '    <div class="nf-field-element">' +
                '      <div class="text-3">' + msg + '</div>' +
                '    </div>' +
                '  </div>' +
                '</div>'
            );
        }

        // if Swiper exists — recalc height (optional but useful)
        if ($(swiperContainer).length > 0) {
            swiperMultistep.updateAutoHeight();
        }
    }

    function getCurrentTariffId() {
        const tariffId = $('input#hiddenTariffId').val();
        if (tariffId) return String(tariffId);

        return '';
    }

    function autoApplyCouponByTariff() {
        // if coupon already applied manually — don't override
        if (apiService && apiService.couponCode) return;

        const tariffId = getCurrentTariffId();
        if (!tariffId) return;

        $.ajax({
            url: myajax.url,
            type: 'POST',
            data: {
                action: 'verify_coupon_by_tariff',
                tariff_id: tariffId,
                nonce: myajax.nonces.verify_coupon_by_tariff,
            },
            success: function (response) {
                if (!response || !response.success) return;

                // if no coupon for this tariff -> do nothing, leave input visible
                if (!response.data || !response.data.has_coupon) return;

                // apply coupon + lock UI
                applyCouponToUI(response.data);
            }
        });
    }

    function updateStepLine(index) {
        const stepLineFilled = $('.step-line .filled');

        stepLineFilled.css('width', `${(index + 1) / swiperMultistep.slides.length * 80}%`);
    }

    function validateInputsOnSlide(index) {
        const currentSlide = swiperMultistep.slides[index];
        const inputs = $(currentSlide).find(':input');
        const selects = $(currentSlide).find('select');
        let allValid = true;

        inputs.each(function () {
            let $containerOfInput = $(this).closest('.nf-field-container');
            let $wrapOfInput = $(this).closest('.field-wrap');

            if(!$containerOfInput.hasClass('required-if-showed')) {
                form.validate().element(this);
                if (!this.checkValidity() || $wrapOfInput.hasClass('nf-error')) {
                    allValid = false;
                }
            }
        });

        selects.each(function () {
            let $containerOfInput = $(this).closest('.nf-field-container');
            let $wrapOfInput = $(this).closest('.field-wrap')

            if(!$containerOfInput.hasClass('required-if-showed')) {
                form.validate().element(this);
                if (!this.checkValidity() || $wrapOfInput.hasClass('nf-error')) {
                    allValid = false;
                }
            }
        });

        return allValid;
    }

    function validateInputsInSelector(selector) {
        const inputs = $(selector).find(':input');
        const selects = $(selector).find('select');
        let allValid = true;

        inputs.each(function () {
            let $containerOfInput = $(this).closest('.nf-field-container');
            let $wrapOfInput = $(this).closest('.field-wrap');

            if(!$containerOfInput.hasClass('required-if-showed')) {
                form.validate().element(this);
                if (!this.checkValidity() || $wrapOfInput.hasClass('nf-error')) {
                    allValid = false;
                }
            }
        });

        selects.each(function () {
            let $containerOfInput = $(this).closest('.nf-field-container');
            let $wrapOfInput = $(this).closest('.field-wrap');

            if(!$containerOfInput.hasClass('required-if-showed')) {
                form.validate().element(this);
                if (!this.checkValidity() || $wrapOfInput.hasClass('nf-error')) {
                    allValid = false;
                }
            }
        });

        return allValid;
    }

    function scrollToElem(elem, error = false) {
        const $customerSwitcher = $('.customer-switcher');
        let headerHeight = $("header").outerHeight() + ($customerSwitcher.length ? $customerSwitcher.outerHeight() : 0);

        if(elem.closest('.collapsed-data').length > 0 && error) {
            if(error) {
                elem = elem.parent();
            }

            const $item = elem.closest('.item');
            const $collectedInfoBox = $item.find('.collected-info');
            const $formFieldsBox = $item.find('.form-fields');
            $collectedInfoBox.hide();
            $formFieldsBox.show();

            setTimeout(function () {
                $("html, body").animate({
                    scrollTop: elem.offset().top - headerHeight
                }, 300);
            }, 100);
        } else {
            if(error) {
                elem = elem.parent();
            }
            $("html, body").animate({
                scrollTop: elem.offset().top - headerHeight
            }, 300);
        }


    }

    function sliderChangeStep(index) {
        swiperMultistep.allowSlideNext = true;
        swiperMultistep.allowSlidePrev = true;
        swiperMultistep.slideTo(index);
        setTimeout(function () {
            swiperMultistep.allowSlideNext = false;
            swiperMultistep.allowSlidePrev = false;
        }, 10);
    }

    function initializeSelect2() {
        $('.enable-select2 select').each(function () {
            const selectName = $(this).attr('name');
            if (selectName === 'salutation' || selectName === 'dsalutation') {
                $(this).select2({
                    placeholder: "Anrede",
                    minimumResultsForSearch: -1,
                    dropdownParent: $(this).parent()
                });
            } else if(selectName === 'title' || selectName === 'dtitle') {
                $(this).select2({
                    placeholder: "Titel (optional)",
                    minimumResultsForSearch: -1,
                    dropdownParent: $(this).parent()
                });
            } else {
                $(this).select2({
                    minimumResultsForSearch: -1,
                    dropdownParent: $(this).parent()
                });
            }
        });

        $('select[name="title"], select[name="dtitle"]').on('change', function() {
            // if they picked “fake” nullValue
            if (this.value === 'nullValue') {
                // set it back to actual empty
                $(this).val('').trigger('change');
            }
        });

        setTimeout(function () {
            if ($(swiperContainer).length > 0) {
                swiperMultistep.updateAutoHeight();
            }
        }, 10)
    }

    function checkFields() {
        $('.ninja-forms-field:not(.select2-hidden-accessible)').each(function () {
            let $input = $(this);
            let $attr = $(this).attr('required');
            let $container = $input.closest('.nf-field-container');

            $container.addClass('active-label');
            if (!$input.is('select') && !$input.is('input[type=checkbox]') && !$input.is('input[type=radio]')) {
                if ($input.val().trim() !== '') {
                    $container.addClass('label-up');
                } else {
                    $container.removeClass('label-up');
                }
            }
            if (typeof $attr !== 'undefined' && $attr !== false && ((!$.isArray($input.val()) && $input.val().trim() === '') || ($.isArray($input.val()) && $input.val().length > 0))) {
                $container.addClass('potentially-required-label');
            }

            if(($input.is('[type="text"]') || $input.is('[type="email"]') || $input.is('[type="tel"]') || $input.is('[type="number"]') || $input.is('[type="date"]')) && $input.val().trim() !== '') {
                form.validate().element($input[0]);
            }

            if(($input.is('[type="text"]') || $input.is('[type="number"]') || $input.is('[type="tel"]') || $input.is('[type="date"]')) && !$attr && $input.val().trim() !== '') {
                $container.addClass('fake-nf-pass');
            }
        });
    }
    function checkLabels() {
        $('.field-wrap label').each(function() {
            // Get the current text or HTML of the label
            let labelText = $(this).html();

            // Check if the label contains the text "(optional)"
            if (labelText.includes('(optional)')) {
                // Replace the text "(optional)" with the HTML version "<i>(optional)</i>"
                let updatedText = labelText.replace('(optional)', '<i>(optional)</i>');
                // Update the label's content to include the HTML
                $(this).html(updatedText);
            }
        });
    }

    function checkValidForm(currentForm) {
        if (currentForm.valid()) {
            currentForm.find('[type="submit"]').removeAttr('disabled');
        } else {
            currentForm.find('[type="submit"]').attr('disabled', 'true');
        }
    }

    revisionForm.on('input change', 'input, textarea, select', function() {
        checkValidForm(revisionForm);
    });

    function checkFieldsOnStep(step) {
        step = step + 1;
        $('.multistep-slider .slide:nth-child(' + step + ') .ninja-forms-field:not(.select2-hidden-accessible)').each(function () {
            let $input = $(this);
            let $container = $input.closest('.nf-field-container');

            if (!$input.is('select') && !$input.is('input[type=checkbox]') && !$input.is('input[type=radio]')) {
                if ($input.val().trim() !== '') {
                    $container.addClass('label-up');
                } else {
                    $container.removeClass('label-up');
                }
            }
        });
    }

    function initializeForm() {
        initializeSelect2();
        checkFields();
        checkLabels();
    }

    function handleNavigation($currentItem) {
        let $container = $('.steps-breadcrumbs');
        let containerWidth = $container.outerWidth();
        let slideNumber = $currentItem.data('index');

        let totalWidth = getTotalWidth(slideNumber);

        $('.step-link').parent().removeClass('active');
        $currentItem.parent().addClass('active');

        sliderChangeStep(slideNumber);
        updateStepLine(slideNumber);

        if (totalWidth > containerWidth * .8) {
            $container.addClass('first-hide');
        } else {
            $container.removeClass('first-hide');
        }
    }

    function getTotalWidth(number) {
        let totalWidth = 0;
        let $container = $('.steps-breadcrumbs');

        $container.children('li').each(function (index, elem) {
            if (index < number) {
                totalWidth += getWordWidth(index + 1);
            }
        });

        return totalWidth;
    }

    function getWordWidth(number) {
        let $element = $('.steps-breadcrumbs li:nth-child(' + number + ')');

        let wordWidth = $element.innerWidth();

        let paddingLeft = parseFloat($element.css('padding-left')) || 0;
        let paddingRight = parseFloat($element.css('padding-right')) || 0;

        let marginLeft = parseFloat($element.css('margin-left')) || 0;
        let marginRight = parseFloat($element.css('margin-right')) || 0;

        let fullWidth = wordWidth + paddingLeft + paddingRight + marginLeft + marginRight;

        return fullWidth;
    }

    function triggersMatch(triggers) {
        for (let trigger in triggers) {
            const expectedValue = triggers[trigger];
            const $inputTrigger = $('[name="' + trigger + '"]');
            let inputValue = '';

            if ($inputTrigger.is('select')) {
                inputValue = $inputTrigger.val();
            } else if ($inputTrigger.attr('type') === 'checkbox') {
                inputValue = $inputTrigger.is(':checked') ? 'true' : 'false';
            } else if ($inputTrigger.attr('type') === 'radio') {
                inputValue = $('input[name="' + trigger + '"]:checked').val();
            }

            if (String(inputValue) !== String(expectedValue)) {
                return false;
            }
        }

        return true;
    }

    function getContainerTriggers($container, attribute) {
        const rawTriggers = $container.attr(attribute);

        return rawTriggers ? JSON.parse(rawTriggers.replace(/'/g, '"')) : null;
    }

    function updateTriggerState($container) {
        const showTriggers = getContainerTriggers($container, 'data-show-triggers');
        const hideTriggers = getContainerTriggers($container, 'data-hide-triggers');
        const shouldShow = !showTriggers || triggersMatch(showTriggers);
        const shouldHide = Boolean(hideTriggers && triggersMatch(hideTriggers));
        const isVisible = shouldShow && !shouldHide;
        const $triggeredFields = $container.find('input, select');

        $container.toggleClass('-show', shouldShow);
        $container.toggleClass('-hide', shouldHide);

        if ($container.hasClass('show-trigger-container')) {
            return;
        }

        if (isVisible) {
            $container.removeClass('required-if-showed');

            $triggeredFields.each(function () {
                const $field = $(this);

                if ($field.data('required-if-showed') === true) {
                    $field.attr('required', true);
                    $field.removeData('required-if-showed');
                }
            });
            return;
        }

        $container.addClass('required-if-showed');

        $triggeredFields.each(function () {
            const $field = $(this);
            const isRequired = typeof $field.attr('required') !== 'undefined' && $field.attr('required') !== false;

            if (isRequired) {
                $field.data('required-if-showed', true);
                $field.removeAttr('required');
            }

            $field.removeClass('error').removeAttr('aria-invalid');
        });

        $container.find('.field-wrap').removeClass('nf-error');
        $container.find('.nf-error-msg').empty();
    }

    function changeLabelNinjaform() {
        $('.ninja-forms-form-wrap label').each(function() {
            var labelText = $(this).html();

            if(labelText !== '') {
                var updatedText = labelText.replace(/\((.*?)\)/, '<i>($1)</i>');
                $(this).html(updatedText);
            }
        });
    }

    function isNonEmptyTextOrNumber($el) {
        const type = ($el.attr('type') || '').toLowerCase();
        if (type === 'text' || type === 'number') {
            return $.trim($el.val() || '') !== '';
        }
        return true; // not text/number → treat as ok
    }

    if (form.length > 0) {
        $.extend($.validator.messages, {
            required: "Dieses Feld wird benötigt.",
            email: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
            number: "Bitte geben Sie eine gültige Zahl ein.",
            range: $.validator.format("Bitte geben Sie einen Wert zwischen {0} und {1} ein."),
            max: $.validator.format("Bitte geben Sie einen Wert kleiner oder gleich {0} ein."),
            min: $.validator.format("Bitte geben Sie einen Wert größer oder gleich {0} ein."),
            digits: "Nur Zahlen sind erlaubt.",
            rangelength: $.validator.format("Bitte geben Sie genau {0} Zeichen ein.")
        });

        $.validator.addMethod("customEmail", function (value, element) {
            return this.optional(element) || /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value);
        }, "Bitte geben Sie eine gültige E-Mail-Adresse ein.");

        $.validator.addMethod("alphanumeric", function (value, element) {
            return this.optional(element) || /^[a-zA-Z0-9]+$/.test(value);
        }, "Bitte geben Sie nur Buchstaben und Zahlen ein.");

        $.validator.addMethod("lettersDigitsHyphen", function (value, element) {
            return this.optional(element) || /^[a-zA-Z0-9-]+$/.test(value);
        }, "Bitte geben Sie nur Buchstaben, Zahlen und Bindestriche ein.");

        $.validator.addMethod("lettersWithDashesDiacritics", function(value, element) {
            return this.optional(element) || /^[a-zA-ZÀ-ž\- ]+$/.test(value);
        }, "Bitte geben Sie nur Buchstaben, Bindestriche und diakritische Zeichen ein.");

        // Add a custom validation method for checking age range (between 18 and 130 years)
        $.validator.addMethod("dateRange", function(value, element, params) {
            const selectedDate = new Date(value);

            const minDate = params[0];
            const maxDate = params[1];

            return this.optional(element) || (selectedDate >= minDate && selectedDate <= maxDate);
        }, "Ihr Alter muss über 18 oder unter 130 Jahre liegen.");

        $.validator.addMethod("numbersAndPlus", function(value, element) {
            // Allow only numbers and the "+" sign, and also allow empty values
            return this.optional(element) || /^[0-9+]+$/.test(value);
        }, "Bitte geben Sie nur Zahlen und '+' ein");

        $.validator.addMethod("lettersAndDash", function(value, element) {
            // Allow only letters (including umlauts), spaces, and the "-" symbol
            return this.optional(element) || /^[a-zA-ZäöüßÄÖÜ\s-]+$/.test(value);
        }, "Bitte geben Sie nur Buchstaben und '-' ein");

        $.validator.addMethod("lettersAndDashAndDot", function(value, element) {
            // Allow only letters (including umlauts), spaces, the "-" symbol, and "."
            return this.optional(element) || /^[a-zA-ZäöüßÄÖÜ\s\-.]+$/.test(value);
        }, "Bitte geben Sie nur Buchstaben, '-', '.' und Leerzeichen ein");

        $.validator.addMethod("lettersNumbersSlash", function(value, element) {
            // Allow only letters (including umlauts), numbers, spaces, and "/"
            return this.optional(element) || /^[a-zA-ZäöüßÄÖÜ0-9\s/]+$/.test(value);
        }, "Bitte geben Sie nur Buchstaben, Zahlen und '/' ein");

        // Add a custom validation method for checking that the date is not older than 5 weeks
        $.validator.addMethod("notOlderThan5Weeks", function(value, element) {
            const selectedDate = new Date(value);

            const currentDate = new Date();

            const fiveWeeksAgo = new Date();
            fiveWeeksAgo.setDate(currentDate.getDate() - 35);

            return this.optional(element) || selectedDate >= fiveWeeksAgo;
        }, "Dein Einzugsdatum liegt mehr als 4 Wochen zurück");

        // Validation method: checks that IBAN contains exactly 22 characters (excluding spaces)
        $.validator.addMethod("ibanLength", function(value, element) {
            // Remove all spaces
            var valueWithoutSpaces = value.replace(/\s+/g, '');
            var valueWithoutLines = valueWithoutSpaces.replace('_', '');
            // Check that the length is exactly 22 characters
            return valueWithoutLines.length === 22;
        }, "IBAN muss 22 Zeichen lang sein");

        // Validation method: checks that the first two letters are 'DE'
        $.validator.addMethod("germanIbanPrefix", function(value, element) {
            // Remove all spaces to ensure correct checking regardless of formatting
            var valueWithoutSpaces = value.replace(/\s+/g, '');
            // Check that the first two letters are 'DE'
            return /^DE/.test(valueWithoutSpaces);
        }, "Bitte gib eine deutsche IBAN an");

        $.validator.addMethod("germanIbanValidation", function(value, element) {
            // Remove all spaces and convert to uppercase
            var iban = value.replace(/\s+/g, '').toUpperCase();

            // Check that IBAN matches German format (DE + 20 цифр)
            if (!/^DE\d{20}$/.test(iban)) {
                return false;
            }

            // Rearrangement: move the first 4 characters (country code and check digits) to the end
            var rearranged = iban.slice(4) + iban.slice(0, 4);

            // Convert letters to numbers (A=10, B=11, ..., Z=35)
            var numericIban = "";
            for (var i = 0; i < rearranged.length; i++) {
                var ch = rearranged.charAt(i);
                if (ch >= 'A' && ch <= 'Z') {
                    numericIban += (ch.charCodeAt(0) - 55);
                } else {
                    numericIban += ch;
                }
            }

            // Perform mod-97 validation in chunks to avoid precision issues for very long numbers
            var remainder = numericIban;
            while (remainder.length > 2) {
                var block = remainder.substring(0, 9);
                remainder = (parseInt(block, 10) % 97).toString() + remainder.substring(block.length);
            }

            return parseInt(remainder, 10) % 97 === 1;
        }, "Die eingegebene IBAN ist ungültig, bitte überprüfe Deine Eingabe");

        $.validator.addMethod("dateFuture", function(value, element) {
            const selectedDate = new Date(value);

            const currentDate = new Date();

            selectedDate.setHours(0, 0, 0, 0);
            currentDate.setHours(0, 0, 0, 0);

            if (element.name === 'supplyBeginDate') {
                const maxDate = new Date();

                maxDate.setMonth(maxDate.getMonth() + 12);
                maxDate.setHours(0, 0, 0, 0);

                return this.optional(element) || (selectedDate > currentDate && selectedDate <= maxDate);
            }

            return this.optional(element) || selectedDate > currentDate;
        }, function(params, element) {
            if (element.name === 'supplyBeginDate') {
                return "Datum muss in der Zukunft liegen und max. 12 Monate";
            }

            return "Datum muss in der Zukunft liegen";
        });

        $.validator.addMethod("dateFuturePlusToday", function(value, element) {
            const selectedDate = new Date(value);

            const currentDate = new Date();

            selectedDate.setHours(0, 0, 0, 0);
            currentDate.setHours(0, 0, 0, 0);

            return this.optional(element) || selectedDate >= currentDate;
        }, "Datum muss in der Zukunft liegen");

        const maxDate = new Date();
        maxDate.setFullYear(maxDate.getFullYear() - 18);
        maxDate.setHours(0, 0, 0, 0);

        const minDate = new Date();
        minDate.setFullYear(minDate.getFullYear() - 130);
        minDate.setHours(0, 0, 0, 0);

        form.validate({
            ignore: ".datepicker-18.input, .datepicker-5.input, .datepicker.input",
            rules: {
                email: {
                    customEmail: true
                },
                demail: {
                    customEmail: true
                },
                deliveryPointMeteringDeviceNumber: {
                    lettersDigitsHyphen: {
                        param: true,
                    }
                },
                postalCode: {
                    digits: true,
                    rangelength: [5, 5]
                },
                dpostalCode: {
                    digits: true,
                    rangelength: [5, 5]
                },
                movePostalCode: {
                    digits: true,
                    rangelength: [5, 5]
                },
                firstname: {
                    lettersWithDashesDiacritics: true
                },
                lastname: {
                    lettersWithDashesDiacritics: true
                },
                dfirstname: {
                    lettersWithDashesDiacritics: true
                },
                dlastname: {
                    lettersWithDashesDiacritics: true
                },
                housenumber: {
                    digits: true,
                },
                dhousenumber: {
                    digits: true,
                },
                moveHousenumber: {
                    digits: true,
                },
                dateOfBirth: {
                    dateRange: [minDate, maxDate]
                },
                supplyBeginDate: {
                    dateFuture: true
                },
                phoneNumber: {
                    numbersAndPlus: true
                },
                dstreet: {
                    lettersAndDashAndDot: true
                },
                moveStreet: {
                    lettersAndDashAndDot: true
                },
                moveHousenumberAddition: {
                    lettersNumbersSlash: true
                },
                dhousenumberAddition: {
                    lettersNumbersSlash: true
                },
                housenumberAddition: {
                    lettersNumbersSlash: true
                },
                dcity: {
                    lettersAndDash: true
                },
                marketLocation: {
                    rangelength: {
                        param: [11, 11],
                    },
                    digits: {
                        param: true,
                    }
                },
                moveCity: {
                    lettersAndDash: true
                },
                bankAccountIban: {
                    ibanLength: true,
                    germanIbanPrefix: true,
                    germanIbanValidation: true
                },
                supplierOldCancellationDate: {
                    dateFuturePlusToday: true
                }
            },
            errorPlacement: function (error, element) {
                error.appendTo(element.closest('.field-wrap').find('.nf-error-msg'));
                if ($(swiperContainer).length > 0) {
                    swiperMultistep.updateAutoHeight();
                } // Update Swiper height when error message is shown
            },
            highlight: function (element) {
                $(element).closest('.field-wrap').addClass('nf-error').removeClass('nf-pass');
                if ($(swiperContainer).length > 0) {
                    swiperMultistep.updateAutoHeight();
                } // Update Swiper height when field is highlighted
            },
            unhighlight: function (element) {
                $(element).closest('.field-wrap').removeClass('nf-error');
                if ($(swiperContainer).length > 0) {
                    swiperMultistep.updateAutoHeight();
                } // Update Swiper height when field is unhighlighted
            },
            success: function (label, element) {
                const $el = $(element);
                const $wrap = $el.closest('.field-wrap');

                // For text/number → add nf-pass only if not empty
                if (!isNonEmptyTextOrNumber($el)) {
                    $wrap.removeClass('nf-pass');
                    return;
                }

                $wrap.addClass('nf-pass');

                if ($(swiperContainer).length > 0) {
                    swiperMultistep.updateAutoHeight();
                } // Update Swiper height when field is valid
            }
        });

        $('[name="bankAccountIban"]').inputmask({
            mask: "DE99 9999 9999 9999 9999 99",
            placeholder: "",
            clearIncomplete: false,
            rightAlign: false,
            definitions: {
                '9': {
                    validator: "[0-9]",
                    cardinality: 1
                }
            }
        });
    }

    if(revisionForm.length) {
        checkValidForm(revisionForm);
    }

    updateStepLine(0);

    simpleDatePicker.each(function() {
        const $pickerElement = $(this);

        const fp = $pickerElement.flatpickr({
            locale: German,
            altInput: true,
            altFormat: "d.m.Y",
            dateFormat: "Y-m-d",
            clickOpens: false,
            allowInput: true,
            disableMobile: true,
            onValueUpdate: function(selectedDates, dateStr, instance) {
                $pickerElement.valid();
            }
        });

        $pickerElement.closest('.nf-field-element').find(".date-icon").on("click", function() {
            fp.open();
        });
    });

    customDatePicker.each(function() {
        const $pickerElement = $(this);

        const fp = $pickerElement.flatpickr({
            locale: German,
            altInput: true,
            altFormat: "d.m.Y",
            dateFormat: "Y-m-d",
            allowInput: true,
            clickOpens: false,
            disableMobile: true,
            onValueUpdate: function(selectedDates, dateStr, instance) {
                $pickerElement.valid();
            },
            onClose: function(selectedDates, dateStr, instance){
                $pickerElement.valid();
            }
        });

        $pickerElement.closest('.nf-field-element').find(".date-icon").on("click", function() {
            fp.open();
        });
    });

    custom2DatePicker.each(function() {
        const $pickerElement = $(this);

        const fp = $pickerElement.flatpickr({
            locale: German,
            altInput: true,
            altFormat: "d.m.Y",
            dateFormat: "Y-m-d",
            allowInput: true,
            clickOpens: false,
            disableMobile: true,
            onValueUpdate: function(selectedDates, dateStr, instance) {
                $pickerElement.valid();
            }
        });

        $pickerElement.closest('.nf-field-element').find(".date-icon").on("click", function() {
            fp.open();
        });
    });

    $(document).on('focus', '.date-container .input', function () {
        $(this).inputmask({
            mask: "99.99.9999",
            placeholder: "tt.mm.jjjj",
            clearIncomplete: true
        });
    });

    $(document).on('blur', '.date-container .input', function () {
        $(this).inputmask('remove');
        $(this).attr('placeholder', '');
    });

    $(document).on('keydown', function(e) {
        if (e.key === 'Tab') {
            const $current = $(':focus');

            if ($current.hasClass('button-next')) {
                e.preventDefault();
            }
        }
    });

    initializeForm();

    $(document).on('nfFormReady', function (e) {
        initializeForm();
        changeLabelNinjaform();
    });

    nextButtons.on('click', function (e) {
        e.preventDefault();
        const currentIndex = swiperMultistep.activeIndex;
        const nextNavItem = $('.steps-breadcrumbs li').eq(currentIndex + 1).find('a');

        const currentSlide = swiperMultistep.slides[currentIndex];

        let allValid = validateInputsOnSlide(currentIndex);

        if (allValid) {
            handleNavigation(nextNavItem);

            sliderChangeStep(currentIndex + 1);

            checkFieldsOnStep(currentIndex + 1);

            scrollToElem(formBox);

            const buttonId = $(this).attr('id');
            if (!clickedButtons.includes(buttonId)) {
                clickedButtons.push(buttonId);

                sendTag(buttonId, 'google');
                sendTag(buttonId, 'matomo');
            }
        } else {
            if($(currentSlide).find('.field-wrap.nf-error').length) {
                let $errorWrap = $(currentSlide).find('.field-wrap.nf-error');
                let $errorInput = $errorWrap.find('input[type="text"], input[type="email"], input[type="tel"], input[type="number"]');

                scrollToElem($errorWrap, true);

                if($errorInput.length) {
                    $errorInput.focus();
                }
            }
        }
    });

    prevLinks.on('click', function (e) {
        e.preventDefault();
        const currentIndex = swiperMultistep.activeIndex;
        let pageUrl = $(this).attr('href');
        const prevNavItem = $('.steps-breadcrumbs li').eq(currentIndex - 1).find('a');

        const currentSlide = swiperMultistep.slides[currentIndex];

        if (currentIndex > 0) {

            handleNavigation(prevNavItem);

            sliderChangeStep(currentIndex - 1);

            scrollToElem(formBox);

        } else {
            if (pageUrl !== '' && pageUrl !== '#' && pageUrl !== undefined) {
                window.location.href = pageUrl;
            } else {
                history.back();
            }
        }
    });

    inputs.on('keyup blur change', function () {
        let $input = $(this);
        let $attr =  $input.attr('required');
        let $container = $input.closest('.nf-field-container');
        let $wrap = $input.closest('.field-wrap');

        form.validate().element(this);


        if(($input.is('[type="text"]') || $input.is('[type="number"]') || $input.is('[type="tel"]') || $input.is('[type="date"]')) && !$attr) {
            if($input.val().trim() !== '') {
                $container.addClass('fake-nf-pass');
            } else {
                $container.removeClass('fake-nf-pass');
                $wrap.removeClass('nf-pass');
            }
        }
    });

    selectsAll.on('change', function () {
        let $select = $(this);
        let $container = $select.closest('.listselect-container').length ? $select.closest('.listselect-container'): $select.closest('.textbox_with_tooltip-container');
        let valueSelect = $select.val();

        if(($.isArray(valueSelect) && valueSelect.length > 0) || (!$.isArray(valueSelect) && $select.val() !== '')) {
            $container.addClass('fake-nf-pass');
        } else {
            $container.removeClass('fake-nf-pass');
        }
    });

    $(document).on('focus', '.ninja-forms-field', function () {
        let $input = $(this);
        let $container = $input.closest('.nf-field-container');

        $container.addClass('label-focus');
        $container.removeClass('potentially-required-label');
    });

    $(document).on('click', '.promocode-button', function (e) {
        e.preventDefault();

        const $container = $('.promocode-container');
        const $wrap = $('.promocode-wrap');
        const $errorMessage = $wrap.find('.nf-error-msg');
        const $promocodeSuccess = $('.promocode-success');
        const $promocodeButton = $('.promocode-button');
        const couponCode = $('[name="promocode"]').val();

        if(couponCode && couponCode.trim()) {
            $promocodeButton.addClass('loading');
            $.ajax({
                url: myajax.url, // WordPress AJAX URL
                type: 'POST',
                data: {
                    action: 'verify_coupon',
                    coupon: couponCode,
                    nonce: myajax.nonces.verify_coupon,
                },
                success: function (response) {
                    if (response.success) {
                        apiService.couponCode = response.data.code;
                        apiService.couponArt = response.data.art;
                        apiService.couponValue = response.data.value;
                        $container.removeClass('required-label').addClass('blocked');
                        $container.find('input, button').attr('disabled', 'disabled');
                        $wrap.removeClass('nf-error');
                        $errorMessage.html('');

                        if($promocodeSuccess.length) {
                            $promocodeSuccess.find('.nf-field-element').html('<div class="text-3">'+response.data.success_message+'</div>');
                        } else {
                            $container.after('<div class="nf-field-container html-container promocode-success -h4-container">\n' +
                                '    <div class="field-wrap html-wrap">\n' +
                                '        <div class="nf-field-element">\n' +
                                '            <div class="text-3">'+response.data.success_message+'</div>\n' +
                                '        </div>\n' +
                                '    </div>\n' +
                                '</div>');
                        }
                    } else {
                        apiService.couponCode = null;
                        apiService.couponArt = null;
                        apiService.couponValue = null;
                        $container.removeClass('required-label');
                        $wrap.addClass('nf-error');
                        $promocodeSuccess.remove();
                        $errorMessage.html(`<label id="nf-field-4-46-error" class="error" for="nf-field-4-46">${response.data}</label>`);
                    }

                    $promocodeButton.removeClass('loading');
                },
                error: function () {
                    apiService.couponCode = null;
                    apiService.couponArt = null;
                    apiService.couponValue = null;
                    $container.removeClass('required-label');
                    $wrap.addClass('nf-error');
                    $promocodeSuccess.remove();
                    $errorMessage.html(`<label id="nf-field-4-46-error" class="error" for="nf-field-4-46">Da ist etwas schiefgelaufen</label>`);

                    $promocodeButton.removeClass('loading');
                }
            });
        } else {
            $container.addClass('required-label');
            $wrap.addClass('nf-error');
            $promocodeSuccess.remove();
            $errorMessage.html('<label id="nf-field-4-46-error" class="error" for="nf-field-4-46">Dieses Feld wird benötigt.</label>');
        }
    });

    $(document).on('blur', '.ninja-forms-field', function () {
        let $input = $(this);
        let $attr = $input.attr('required');
        let $container = $input.closest('.nf-field-container');

        $container.removeClass('potentially-required-label');
        $container.removeClass('label-focus');
        if ($input.val().trim() === '') {
            if (typeof $attr !== 'undefined' && $attr !== false) {
                $container.addClass('required-label');
            }
        } else {
            if (typeof $attr !== 'undefined' && $attr !== false) {
                $container.removeClass('required-label');
            }
        }
    });

    $(document).on('input', '.ninja-forms-field', function () {
        let $input = $(this);
        let $attr = $input.attr('required');
        let $container = $input.closest('.nf-field-container');
        let value = $input.val();

        if ($input.is('select[multiple]')) {
            value = Array.isArray(value) && value.length > 0 ? value.join('').trim() : '';
        } else if ($input.is('select')) {
            value = value ? value.trim() : '';
        } else if (typeof value === 'string') {
            value = value.trim();
        } else {
            value = '';
        }

        $container.removeClass('potentially-required-label');
        if (value !== '') {
            $container.addClass('label-up');
            if (typeof $attr !== 'undefined' && $attr !== false) {
                $container.removeClass('required-label');
            }
        } else {
            $container.removeClass('label-up');
            if (typeof $attr !== 'undefined' && $attr !== false) {
                $container.addClass('required-label');
            }
        }
    });

    $(document).on('click', '.step-link', function (e) {
        e.preventDefault();
        if ($(this).parent().hasClass('active')) return;

        if (!$(this).hasClass('ready-to-click')) return;

        const currentIndex = swiperMultistep.activeIndex;
        const nextIndex = $(this).data('index');
        let allValid = true;
        const currentSlide = swiperMultistep.slides[currentIndex];

        if(nextIndex > currentIndex) {
            allValid = validateInputsOnSlide(currentIndex);

            if (allValid) {
                handleNavigation($(this));

                sliderChangeStep(nextIndex);

                checkFieldsOnStep(nextIndex);

                scrollToElem(formBox);

                const buttonId = $(currentSlide).find('.button-next').attr('id');
                if (!clickedButtons.includes(buttonId)) {
                    clickedButtons.push(buttonId);

                    sendTag(buttonId, 'google');
                    sendTag(buttonId, 'matomo');
                }
            } else {
                if($(currentSlide).find('.field-wrap.nf-error').length) {
                    let $errorWrap = $(currentSlide).find('.field-wrap.nf-error');
                    let $errorInput = $errorWrap.find('input[type="text"], input[type="email"], input[type="tel"], input[type="number"]');

                    scrollToElem($errorWrap, true);

                    if($errorInput.length) {
                        $errorInput.focus();
                    }
                }
            }
        } else {
            handleNavigation($(this));

            sliderChangeStep(nextIndex);

            checkFieldsOnStep(nextIndex);

            scrollToElem(formBox);
        }

    });

    $(document).ready(function() {
        autoApplyCouponByTariff();
    });

    // Function to verify reCAPTCHA token with a promise
    function verifyRecaptcha() {
        return new Promise((resolve, reject) => {
            grecaptcha.ready(function () {
                grecaptcha.execute(myajax.grecaptcha_site_key, { action: 'submit' }).then(function (token) {
                    // Perform AJAX request to server for token verification
                    $.ajax({
                        url: myajax.url, // WordPress AJAX URL
                        type: 'POST',
                        data: {
                            action: 'verify_recaptcha',
                            token: token,
                            nonce: myajax.nonces.verify_recaptcha,
                        },
                        success: function (response) {
                            if (response.success) {
                                resolve(); // reCAPTCHA verification successful
                            } else {
                                reject('reCAPTCHA verification failed');
                            }
                        },
                        error: function () {
                            reject('Error in reCAPTCHA verification request');
                        }
                    });
                });
            });
        });
    }

    // Event listener for form submission
    multistepForm.on('submit', function (e) {
        e.preventDefault();

        const $form = $(this); // Store the form reference
        const $submitButton = $form.find('button[type="submit"]'); // Store the submit button reference
        const currentIndex = swiperMultistep.activeIndex;
        const currentSlide = swiperMultistep.slides[currentIndex];

        // Disable the submit button
        $submitButton.prop('disabled', true);
        $submitButton.addClass('loading');

        // Validate the active slide first
        if (!validateInputsOnSlide(swiperMultistep.activeIndex)) {

            if($(currentSlide).find('.field-wrap.nf-error').length) {
                let $errorWrap = $(currentSlide).find('.field-wrap.nf-error');
                let $errorInput = $errorWrap.find('input[type="text"], input[type="email"], input[type="tel"], input[type="number"]');

                scrollToElem($errorWrap, true);

                if($errorInput.length) {
                    $errorInput.focus();
                }
            }

            $submitButton.prop('disabled', false); // Enable the button if validation fails
            $submitButton.removeClass('loading');
            return;
        }

        let allSlidesValid = true;
        let firstInvalidSlideIndex = null;

        // Validate all slides starting from the beginning
        swiperMultistep.slides.forEach((slide, index) => {
            if (!validateInputsOnSlide(index)) {
                allSlidesValid = false;
                if (firstInvalidSlideIndex === null) {
                    firstInvalidSlideIndex = index;
                }
                return false; // Break out of the loop if any field is invalid
            }
        });

        if (!allSlidesValid && firstInvalidSlideIndex !== null) {
            const nextNavItem = $('.steps-breadcrumbs li').eq(firstInvalidSlideIndex).find('a');

            handleNavigation(nextNavItem);

            sliderChangeStep(firstInvalidSlideIndex);

            checkFieldsOnStep(firstInvalidSlideIndex);

            scrollToElem(formBox);

            $submitButton.prop('disabled', false); // Enable the button if there are invalid slides
            $submitButton.removeClass('loading');
        } else {
            $submitButton.prop('disabled', true);
            $submitButton.addClass('loading');

            try {
                verifyRecaptcha()
                    .then(() => {
                        apiService.sendCollectDate(); // Send data if reCAPTCHA is verified
                    })
                    .catch((error) => {
                        console.error('Verification error:', error);
                        alert('reCAPTCHA failed. Please try again.'); // Alert user if reCAPTCHA fails
                        $submitButton.removeClass('loading').prop('disabled', false);
                    });
            } catch (error) {
                console.error('Error during reCAPTCHA verification:', error);
                $submitButton.removeClass('loading').prop('disabled', false);
            }
        }
    });

    $('[data-show-triggers], [data-hide-triggers]').each(function () {
        updateTriggerState($(this));
    });

    $('.checkbox-container input, .listcheckbox-container input, .listselect-container select').on('change', function () {
        $('[data-show-triggers], [data-hide-triggers]').each(function () {
            updateTriggerState($(this));
        });

        setTimeout(function () {
            if ($(swiperContainer).length > 0) {
                swiperMultistep.updateAutoHeight();
            }
        }, 10);
    });

    $(document).on('click', '.collapsed-data .open-fields-link a, .collapsed-data .close-fields-link a', function (e) {
        e.preventDefault();
        const $item = $(this).closest('.item');
        const $collectedInfoBox = $item.find('.collected-info');
        const $formFieldsBox = $item.find('.form-fields');

        if ($(this).parent().hasClass('open-fields-link')) {
            $collectedInfoBox.hide();
            $formFieldsBox.show();
        } else {
            if (!validateInputsInSelector($formFieldsBox)) return;
            $collectedInfoBox.show();
            $formFieldsBox.hide();
        }

        scrollToElem($item);

        setTimeout(function () {
            if ($(swiperContainer).length > 0) {
                swiperMultistep.updateAutoHeight();
            }
        }, 10)
    });

    $(document).on('click', '.date-container label', function (e) {
        e.preventDefault();
        let fieldId = $(this).attr('for');
        let currentField = $('#' + fieldId);

        if (currentField.length > 0) {
            if (currentField.attr('type') === 'hidden') {
                currentField = currentField.next();
            }
        }

        currentField.focus();
    });

    if ($(swiperContainer).length > 0) {
        document.querySelector(swiperContainer).addEventListener('keydown', function (event) {
            if (event.key === 'Enter' || event.keyCode === 13) {
                event.preventDefault();
            }
        });
    }

    function updateSubmitButtonStyle(isChecked) {
        $('.multi-step_form:not(.-revision) [type=submit]').css({
            'opacity': isChecked ? '1' : '0.8',
            'pointer-events': isChecked ? 'auto' : 'none'
        });
    }

    updateSubmitButtonStyle(false);

    function onCheckboxChange() {
        updateSubmitButtonStyle(this.checked);
    }

    $('input[name="generalApprove"]').on('change', onCheckboxChange);

});
